import { SearchResultsTab } from '../types/search';
import type { User } from '../types/User';

/**
 * Returns the default search results tab based on the user's membership status.
 *
 * This is used when no tab is specified (e.g., initial page load, missing sessionStorage tabKey).
 *
 * @param user - Optional user object. If not provided, returns MINDITEMS.
 * @returns SearchResultsTab.ALL for core members, SearchResultsTab.MINDITEMS otherwise.
 */
export const getDefaultSearchResultTab = (user?: User): SearchResultsTab => {
	if (!user) return SearchResultsTab.MINDITEMS;
	return user.isCoreMember ? SearchResultsTab.ALL : SearchResultsTab.MINDITEMS;
};
